const DSA_TOPICS = {
  ARRAY: 'array',
  STRING: 'string',
  LINKED_LIST: 'linked-list',
  HASH_TABLE: 'hash-table',
  DYNAMIC_PROGRAMMING: 'dynamic-programming',
  STACK: 'stack',
  QUEUE: 'queue',
  GREEDY: 'greedy',
  MATH: 'math',
  SORTING: 'sorting',
  BINARY_SEARCH: 'binary-search',
  GRAPH: 'graph',
  TREE: 'tree',
  TRIE: 'trie',
  BIT_MANIPULATION: 'bit-manipulation',
  RECURSION: 'recursion',
  BACKTRACKING: 'backtracking',
  HEAP: 'heap',
  SLIDING_WINDOW: 'sliding-window'
};

Object.freeze(DSA_TOPICS);

export default DSA_TOPICS; 